module.exports = __webpack_public_path__ + "static/mozfest-audience-94a39795453ab08859cb4156fe090911.jpg";